module.exports = __webpack_public_path__ + "img/美凯龙@2x.920b6a59.png";